import { useEffect } from 'react';

import { LOCALSTORAGE } from '@/utils/constants/AppConstants';

const deleteAllCookies = () => {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    // Delete cookie by setting expiration date to past
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
  }
};

export const useVersionCheck = () => {
  useEffect(() => {
    const currentVersion = process.env.REACT_APP_VERSION;
    if (!currentVersion) return;

    const storedVersion = localStorage.getItem(LOCALSTORAGE.APP_VERSION);

    if (storedVersion !== currentVersion) {
      // 1. Clear all Storage
      localStorage.clear();
      sessionStorage.clear();

      // 2. Delete Cookies (if cookies are created from FE or same domain without HttpOnly)
      deleteAllCookies();

      // 3. Update new version to localStorage to avoid infinite loop
      localStorage.setItem(LOCALSTORAGE.APP_VERSION, currentVersion);

      // 4. Force reload page to clear cache completely and get new code
      window.location.reload();
    } else if (!storedVersion) {
      // First time accessing app
      localStorage.setItem(LOCALSTORAGE.APP_VERSION, currentVersion);
    }
  }, []);
};
